<script>
import { Form, Field, Toast, Dialog } from 'vant'
import ImageUploader from '@/components/org/ImageUploader'
import PickerSelector from '@/components/org/PickerSelector'
import BottomToolbar from '@/components/org/BottomToolbar'
import Staff from '@/tbs/model/vo/Staff'
import { QNImageUtil } from '@/utils'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-staff-edit',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-form': Form,
        'van-field': Field,
        'image-uploader': ImageUploader,
        'picker-selector': PickerSelector,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            staff: {
                id: null,
                organizationId: null,
                name: null,
                logoUrl: null,
                role: null,
                remark: null,
                isLogon: null,
                isSuperAdmin: null,
            },
            matchId: null,
            isEdit: null,
            locale: {}
        }
    },
    
    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        roleOptions() {
            const type = this.matchId ? 'match' : 'organization'
            return (new Staff).getRoleOptions(type)
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onSubmitBtnClick() {
            console.log('onSubmitBtnClick')
            if (!this.validateSubmitRequired()) {
                // disable to submit and toast the message
                if (!this.staff.name) {
                    Toast(this.locale['staff-name-required'])
                }
                else if (!this.staff.role) {
                    Toast(this.locale['staff-role-required'])
                }
            }
            else {
                // enable to submit
                this.submitData()
            }
        },
        onDeleteBtnClick() {
            console.log('onDeleteBtnClick')
            Dialog.confirm({
                title: this.locale['delete-staff'],
                message: this.locale['delete-staff-confirm-message']
            }).then(() => {
                // on confirm
                this.$emit('custom-event', {
                    type: 'delete'
                })
            }).catch(() => {
                // on cancel
            })
        },
        onLogoUploaderDataChange(data) {
            console.log('onLogoUploaderDataChange', this.isEdit, data)
            this.staff.logoUrl = data
        },
        onRoleDataChange(data) {
            console.log('onRoleDataChange', data.value)
            this.staff.role = data.value
        },
        //--------------------------------------------------
        // private method
        //--------------------------------------------------
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
        validateSubmitRequired() {
            // console.log('validateSubmitRequired')
            if (this.staff.name && this.staff.role) {
                return true
            }
            else {
                return false
            }
        },
        submitData() {
            if (this.validateSubmitRequired()) {
                this.$emit('custom-event', {
                    type: 'save',
                    data: this.staff
                })
            }
        }
    },
}
</script>

<template>
    <div class="staff-edit">
        <van-form>
            <van-field 
                name="staff-name" 
                v-model="staff.name" 
                :label="locale['staff-name-label']" :placeholder="locale['staff-name-placeholder']"
                clearable
                input-align="right"
                maxlength="30" 
            />
            <picker-selector
                :label="locale['staff-role-label']"
                :options="roleOptions"
                :value="staff.role"
                @change-data="onRoleDataChange"
            />
            <image-uploader
                :label="locale['staff-logo-label']"
                :description="locale['staff-logo-placeholder']"
                :oversizeMax="5000*1024"
                :oversizeHint="locale['upload-image-oversize']"
                :imageUrl="adjustImageSize(this.staff.logoUrl, 400, 400)"
                @change-data="onLogoUploaderDataChange"
            />
            <van-field 
                name="staff-remark" 
                v-model="staff.remark" 
                :label="locale['staff-remark-label']" :placeholder="locale['staff-remark-placeholder']"
                clearable
                input-align="right"
                type="textarea"
                rows="1"
                autosize
                maxlength="100" 
            />
        </van-form>
        <bottom-toolbar 
            v-if="!isEdit"
            type="button" 
            :mainButtonLabel="locale['submit']"
            :mainButtonDisabled="!validateSubmitRequired()"
            @click-main-button="onSubmitBtnClick"
        />
        <bottom-toolbar 
            v-else
            type="button-button" 
            :mainButtonLabel="locale['submit']"
            :mainButtonDisabled="!validateSubmitRequired()"
            :minorButtonLabel="locale['delete']"
            @click-main-button="onSubmitBtnClick"
            @click-minor-button="onDeleteBtnClick"
        />
    </div>
</template>